import React, { lazy, Suspense, useEffect, useState } from "react";

import images from "../exports/images";

import usePgiModules from "../hooks/useModules";
import { Helmet, HelmetProvider } from "react-helmet-async";
import CarouselMobile from "../components/carousel/CarouselMobile";
import CarouselMobileProdEspeciales from "../components/carousel/CarouselMobileProdEspeciales";

const SliderHome = lazy(() => import("../components/SliderHome"));
// const Carousel = lazy(() => import("../components/carousel/Carousel"));
// const CarouselProdEspeciales = lazy(() => import("../components/carousel/CarouselProdEspeciales"));
const BannerPub = lazy(() => import("../components/BannerPub"));
const HomeNews = lazy(() => import("../components/news/HomeNews"));
const ModuleBlockNews = lazy(() => import("../components/news/ModuleBlockNews"));

const Home = () => {
  const isHomePage = true;
  useEffect(() => {
    const handleScroll = () => {
      const altoDeViewPortDelCliente = document.body.clientHeight;
      let scrollTop = document.documentElement.scrollTop;
      const inRightElements = Array.from(document.getElementsByClassName("inRight"));
      const inLeftElements = Array.from(document.getElementsByClassName("inLeft"));
      const inDownElements = Array.from(document.getElementsByClassName("inDown"));
      const inUpElements = Array.from(document.getElementsByClassName("inUp"));

      const inElements = Array.from(document.getElementsByClassName("in"));

      const imgParallaxY = Array.from(document.getElementsByClassName("img-parallax-y"));
      const imgParallaxX = Array.from(document.getElementsByClassName("img-parallax-x"));
      const zoomOutElements = Array.from(document.getElementsByClassName("zoomOut"));

      inRightElements.forEach((item, index) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.3) {
          item.classList.remove("inRight");
          item.classList.add("fadeInRight");
        }
      });

      inLeftElements.forEach((item, index) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.3) {
          item.classList.remove("inLeft");
          item.classList.add("fadeInLeft");
        }
      });

      inDownElements.forEach((item, index) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.3) {
          item.classList.remove("inDown");
          item.classList.add("fadeInDown");
        }
      });

      inUpElements.forEach((item, index) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.3) {
          item.classList.remove("inUp");
          item.classList.add("fadeInUp");
        }
      });

      inElements.forEach((item, index) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.2) {
          item.classList.remove("in");
          item.classList.add("fadeIn");
        }
      });

      imgParallaxY.forEach((item, index) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.4) {
          item.style.transform = `translateY(${scrollTop * -0.2}px)`;
        }
      });
      imgParallaxX.forEach((item, index) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.6) {
          item.style.transform = `scale(${scrollTop * -0.2})`;
        }
      });

      zoomOutElements.forEach((item, index) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.2) {
          item.classList.remove("zoomOut");
          item.classList.add("fadeZoomOut");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [homeModules, setHomeModules] = useState([]);
  const { getModulesByParams } = usePgiModules();

  useEffect(() => {
    getModulesByParams({ state: true }).then((res) => {
      setHomeModules(
        res.sort((a, b) => {
          return a.position.find((obj) => obj)?.home - b.position.find((obj) => obj)?.home;
        })
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HelmetProvider>
        <Helmet prioritizeSeoTags>
          <title>Tensolite | Fábrica de Premoldeados y Pretensados de Hormigón</title>
          <meta
            name="description"
            content="Fábrica de premoldeados y pretensados de hormigón. Vigueta, bloque, adoquín, teja y productos especiales de hormigón. Obras públicas y civiles."
          />
          <meta name="author" content="Sitenso"></meta>
          <meta
            name="keywords"
            content="+fabrica +cordoba, +fabrica +tucuman, +Fabrica +tensolite,+historia +fabrica +tensolite,+valores +tensolite,empresa tensolite, historia empresa tensolite, +historia +Tensolite,+empresa +constructora +argentina, +empresa +constructora +tucuman, +construcción +argentina, +construcción +tucuman, +historia +tensolite, +Premoldeados +fabrica, +fabrica +premoldeado, premoldeado pretensado hormigón, +premoldeado +pretensado +hormigón, +pretensado +hormigon, +vigueta +pretensada, +vigueta +hormigón, +fábrica +vigueta, +fábrica +bloque +hormigón, +fóbrica +teja,+fóbrica +adoquin, +fabrica postes, [premoldeados de hormigón], [pretensados de hormigón], [fábrica tensolite], fábrica tensolite, [construcción en seco], [fábrica de pretensados de hormigón en argentina], fabrica de pretensados de hormigón, Tensolite"
          />
          {/* Google Tag Manager (noscript) */}
          {/* <noscript>
            {`<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5KRPNJK" height="0" width="0" style="display:none;visibility:hidden"></iframe>`}
          </noscript> */}
          {/* End Google Tag Manager (noscript) */}
          {/* <script>
            {(function (w, d, s, l, i) {
              w[l] = w[l] || [];
              w[l].push({
                "gtm.start": new Date().getTime(),
                event: "gtm.js",
              });
              var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != "dataLayer" ? "&l=" + l : "";
              j.async = true;
              j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
              f.parentNode.insertBefore(j, f);
            })(window, document, "script", "dataLayer", "GTM-5KRPNJK")}
          </script> */}
          <script type="application/ld+json">
            {`
        {
            "@context": "https://schema.org",
            "@type": "Organization" ,
            "name": "Tensolite",
            "author": {
                  "@type": "CreativeWork",
                  "name": "Sitenso"
             },
            "description": "Fábrica de premoldeados y pretensados de hormigón. Vigueta, bloque, adoquín, teja y productos especiales de hormigón. Obras públicas y civiles.",
            "url":"http://tensocom.sitenso.link",
            "telephone": "0381 437-2215",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Tucumán, Argentina",
              "streetAddress": "Ruta Nac.9 Km 1298"
            },
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                  "Monday",
                  "Tuesday", 
                  "Wednesday",
                  "Thursday",
                  "Friday"
                ],
                "opens": "08:00",
                "closes": "17:00"
              },
       `}
          </script>
        </Helmet>
      </HelmetProvider>
      <Suspense fallback={<div> </div>}>
        <SliderHome />
        {homeModules.map((item, index) => {
          switch (item.title) {
            case "Carrousel_deLinea":
              if (item.visible.includes("home")) {
                return (
                  <section key={index} id="modulo-prod-linea-home" className="modul container">
                    {/* <h3 className="in">Productos de Línea</h3> */}
                    <CarouselMobile isHomePage={isHomePage} images={images[0]} />
                    {/* <Carousel images={images[0]} /> */}
                  </section>
                );
              }
              break;
            case "Carrousel_especial":
              if (item.visible.includes("home")) {
                return (
                  <section
                    key={index}
                    id="modulo-prod-especial-home"
                    className="modul container mb-5"
                  >
                    {/* <h3 className="in">Productos Especiales</h3> */}
                    <CarouselMobileProdEspeciales isHomePage={isHomePage} images={images[1]} />
                    {/* <CarouselProdEspeciales key={index} images={images[1]} /> */}
                  </section>
                );
              }
              break;
            case "Banner_publicitario":
              if (item.visible.includes("home")) {
                return <BannerPub key={index} idProducto={"home"} />;
              }
              break;
            case "TensoNews":
              if (item.visible.includes("home")) {
                return <HomeNews key={index} />;
              }
              break;
            case "Bloque_info":
              if (item.visible.includes("home")) {
                return <ModuleBlockNews key={index} idProducto={"home"} />;
              }
              break;
            default:
          }
        })}
      </Suspense>
    </>
  );
};

export default Home;
